<template>
  <div id="app">
    <header-bar v-if="header_show"></header-bar>
    <div class="view-cont" :class="{padT:header_show}">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" @header="header" @footer="footer"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" @header="header" @footer="footer"></router-view>
    </div>
    <footer-bar v-if="footer_show"></footer-bar>
  </div>
</template>
<script>
  import HeaderBar from './components/layout/header-bar'
  import FooterBar from './components/layout/footer-bar'
  export default {
    name: "App",
    data(){
      return {
        header_show:true,
        footer_show:true,
      }
    },
    components: {
      HeaderBar,
      FooterBar
    },
    mounted(){

    },
    methods:{
      //是否显示头部
      header:function (bool) {
        this.header_show = bool;
      },
      //是否显示底部
      footer:function (bool) {
        this.footer_show = bool;
      }
    }

  };



</script>
<style>
  @import url("./assets/css/base.css");
  @import url("./assets/css/style.css");
</style>
